import clsx from 'clsx'
import React from 'react'
import { Control, Controller, UseFormGetValues } from 'react-hook-form'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import { HouseSearchFragment } from '../../../../lib/graphql'
import { Button, BUTTON_COLOR, Icon } from '../../../atoms'
import { HouseSearchSidebarLayout } from '../../../organisms/house-search/house-search-sidebar/HouseSearchSidebar'
import { getHouseSearchSortOptions } from '../../../templates/house-search-layout/house-search-layout.utils'
import { ISearchFormProps } from '../../../templates/house-search-layout/HouseSearchLayout'

interface IHouseSearchMobileOptionsProps {
  control: Control<any, any>
  getValues: UseFormGetValues<ISearchFormProps>
  showSortSelector: boolean
  setShowSortSelector: (show: boolean) => void
  onMapClick: () => void
  showFilterSelector: boolean
  setShowFilterSelector: (show: boolean) => void
  houseSearchFilters: JSX.Element[]
  clearAllFilters: () => void
  activeFilterCount: number
  houses: HouseSearchFragment[] | undefined
}

export const HouseSearchMobileOptions = ({
  control,
  getValues,
  showSortSelector,
  setShowSortSelector,
  onMapClick,
  showFilterSelector,
  setShowFilterSelector,
  houseSearchFilters,
  activeFilterCount,
  houses,
}: IHouseSearchMobileOptionsProps) => {
  const intl = useIntl()

  return (
    <div className={s.houseSearchMobileOptionsContainer}>
      <div
        className={clsx(s.filtersContainer, {
          [s.withoutSortSelector]: !showSortSelector,
        })}
      >
        <Button
          color={BUTTON_COLOR.SECONDARY}
          onClick={() => setShowSortSelector(!showSortSelector)}
          contentClassName={s.button}
        >
          <Icon name='sort' size={15} />
          <div>Trier</div>
        </Button>
        <Button
          color={BUTTON_COLOR.SECONDARY}
          onClick={() => setShowFilterSelector(!showFilterSelector)}
          contentClassName={s.button}
        >
          <Icon name='filter' size={17} />
          <div>Filtrer {activeFilterCount > 0 && `(${activeFilterCount})`}</div>
        </Button>
        <Button
          disabled={houses?.length === 0 || houses === undefined}
          color={BUTTON_COLOR.SECONDARY}
          contentClassName={s.button}
          onClick={onMapClick}
        >
          <Icon name='map' size={14} />
          <div>Carte</div>
        </Button>
      </div>
      {!showSortSelector && (
        <Controller
          control={control}
          name='sortBy'
          render={({ field }) => {
            return (
              <div
                className={clsx(s.mainFilterSelectorController, {
                  [s.noResults]: houses?.length === 0 || houses === undefined,
                })}
              >
                {getHouseSearchSortOptions(intl).map((options) => (
                  <>
                    <div className={s.optionsAndRadioContainer}>
                      <div
                        key={options.value}
                        onClick={() => {
                          field.onChange(options.value)
                          setShowSortSelector(!showSortSelector)
                        }}
                        className={s.optionLabel}
                      >
                        {options.label}
                      </div>
                      <input
                        type='radio'
                        checked={getValues('sortBy') === options.value}
                        onChange={() => {
                          field.onChange(options.value)
                          setShowSortSelector(!showSortSelector)
                        }}
                        className={s.sortRadio}
                      />
                    </div>
                  </>
                ))}
              </div>
            )
          }}
        />
      )}
      {!showFilterSelector && (
        <div className={s.filterSelectorContainer}>
          <div className={s.topBar}>
            <div className={s.topBarTitle}>Filtres</div>
            <button
              onClick={() => {
                setShowFilterSelector(!showFilterSelector)
              }}
              className={s.icon}
            >
              <div>
                <Icon name='cross' size={12} />
              </div>
            </button>
          </div>
          <HouseSearchSidebarLayout filters={houseSearchFilters} />
        </div>
      )}
    </div>
  )
}
